import apiClient from '../apiClient';

/**
 * Get augmentation job by extraction job ID
 * @param {string} extractionJobId - The extraction job ID
 * @returns {Promise} API response with augmentation job data
 */
export const getAugmentationJobByExtractionJobId = async (extractionJobId) => {
  return apiClient.get(`/api/augmentation-review/by-extraction-job/${extractionJobId}`);
};

/**
 * Get augmentation review queue
 * @param {string} customerId - Optional customer ID filter
 * @returns {Promise} API response with review queue items
 */
export const getAugmentationReviewQueue = async (customerId = null) => {
  const params = customerId ? { customerId } : {};
  return apiClient.get('/api/augmentation-review', { params });
};

/**
 * Get augmentation job detail for review
 * @param {string} jobId - The augmentation job ID
 * @returns {Promise} API response with job detail
 */
export const getAugmentationJobDetail = async (jobId) => {
  return apiClient.get(`/api/augmentation-review/${jobId}`);
};

/**
 * Resolve an augmentation job
 * @param {string} jobId - The augmentation job ID
 * @param {Object} resolutionData - Field resolutions
 * @returns {Promise} API response
 */
export const resolveAugmentationJob = async (jobId, resolutionData) => {
  return apiClient.post(`/api/augmentation-review/${jobId}/resolve`, resolutionData);
};

/**
 * Retry a failed augmentation job
 * @param {string} jobId - The augmentation job ID
 * @returns {Promise} API response
 */
export const retryAugmentationJob = async (jobId) => {
  return apiClient.post(`/api/augmentation-review/${jobId}/retry`);
};
